import { $http } from './http'

const API_PATH = '/clients/detail'

class ClientOptServices {
  // Method to get client options
  getDetail = async (clientId: number) => {
    const response = await $http.get(`${API_PATH}/${clientId}`)
    return response.data
  }
}
export default new ClientOptServices()
